import React from "react";
// import { ReactComponent as LeftBg } from "images/background/hero-section-red-triangle.svg";
// import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
// import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";

import Polygon from "../../../images/background/Polygon.png";
import RectangleBorder from "../../../images/background/RectangleBorder.png";
import RectangleLight from "../../../images/background/RectangleLight.png";
import classes from "./HeaderBackground.module.css";

const Index = () => {
  return (
    <div className={classes["main-container"]}>
      <img src={Polygon} className={classes.polygon} />
      <img
        src={RectangleBorder}
        className={classes["rectangle-border-right"]}
      />
      <img src={RectangleLight} className={classes["rectangle-light-red"]} />
    </div>
  );
};

export default Index;
